import { existsSync } from 'node:fs';
import { join } from 'node:path';
import { z } from 'zod';
import { getBackendDataCollectionsExtensionsDir } from '@wix/cli-astro-definitions';
import type { ExtensionDef } from '../generate-schema/types.js';
import { defineField } from '../generate-schema/definitions.js';
import { generateDataCollection } from './generate.js';

const schema = z.object({
  extensionType: z.literal('DATA_COLLECTION'),
  collectionName: z
    .string()
    .regex(/^[A-Za-z0-9_-]{1,36}$/)
    .describe(
      defineField({
        title: 'Collection name',
        description:
          '1-36 characters, letters, numbers, underscores, and hyphens only.',
      })
    ),
});

export const dataCollection: ExtensionDef<typeof schema> = {
  title: 'Data Collection',
  description: 'A backend data collection',
  group: 'Backend',
  documentation:
    'https://dev.wix.com/docs/api-reference/business-solutions/cms/collection-management/data-collections-extension/data-collections-extension-object',
  zodSchema: schema,
  validate: async (projectFolder, data) => {
    const dir = getBackendDataCollectionsExtensionsDir(projectFolder);
    return existsSync(join(dir, `${data.collectionName}.ts`))
      ? 'Collection name must be unique, please choose a name that has not been used yet in your application.'
      : null;
  },
  generate: ({ projectFolder, data }) =>
    generateDataCollection(projectFolder, data.collectionName),
};
